export class ApiError extends Error {
  readonly status: number;
  readonly detail: unknown;

  constructor(status: number, message: string, detail?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.detail = detail;
  }

  static from(response: Pick<Response, "status">, detail?: unknown): ApiError {
    return new ApiError(
      response.status,
      messageFor(response.status, detail),
      detail,
    );
  }

  get isClientError(): boolean {
    return this.status >= 400 && this.status < 500;
  }
}

function messageFor(status: number, detail: unknown): string {
  if (typeof detail === "string" && detail.trim()) return detail;
  if (detail && typeof detail === "object") {
    const record = detail as Record<string, unknown>;
    for (const key of ["message", "error", "title", "detail"]) {
      const value = record[key];
      if (typeof value === "string" && value.trim()) return value;
    }
  }
  switch (status) {
    case 400:
      return "The request was rejected. Check the values and try again.";
    case 401:
      return "Your session has expired. Please sign in again.";
    case 403:
      return "You do not have permission to do that.";
    case 404:
      return "Not found.";
    case 409:
      return "That conflicts with the current state. Reload and try again.";
    case 410:
      return "This feature has been removed.";
    case 500:
      return "Something went wrong on the server.";
    default:
      return `Request failed (HTTP ${status}).`;
  }
}

export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}
